import { render } from "./v-fill-green-button.vue?vue&type=template&id=3b8225ca&scoped=true"
import script from "./v-fill-green-button.vue?vue&type=script&lang=js"
export * from "./v-fill-green-button.vue?vue&type=script&lang=js"

import "./v-fill-green-button.vue?vue&type=style&index=0&id=3b8225ca&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b8225ca"]])

export default __exports__